import { Card } from "../ui/card";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export const SEZ = ({ icon: Icon, title, children }) => (
  <Card className="p-6 border-slate-200">
    <div className="flex items-center gap-2 mb-5">
      <div className="h-8 w-8 rounded-md bg-primary/10 flex items-center justify-center">
        <Icon className="h-4 w-4 text-primary" />
      </div>
      <h3 className="font-semibold text-slate-800 font-heading">{title}</h3>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">{children}</div>
  </Card>
);

export const Field = ({ label, value, onChange, type = "text", testid, full, placeholder, disabled }) => (
  <div className={full ? "md:col-span-2" : ""}>
    <Label className="nx-label">{label}</Label>
    <Input data-testid={testid} type={type} value={value} placeholder={placeholder} disabled={disabled}
      onChange={(e) => onChange(e.target.value)} className="mt-1.5" />
  </div>
);

export const Sel = ({ label, value, onChange, options, testid }) => (
  <div>
    <Label className="nx-label">{label}</Label>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testid} className="mt-1.5"><SelectValue placeholder="Seleziona" /></SelectTrigger>
      <SelectContent>
        {options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}
      </SelectContent>
    </Select>
  </div>
);

export const withCurrent = (options, current) => [...new Set([...options, ...(current ? [current] : [])])];

export const emptyLog = { indirizzo: "", citta: "", reparto_citofono: "", piano: "", scala: "", ascensore: "" };
